<app-header></app-header>
<app-loader></app-loader>
<div class="main">
    <router-outlet></router-outlet>
</div>
